

// import { EaseApp } from "chat-uikit";
import { EaseApp } from "agora-chat-uikit";

const WebIM = EaseApp.getSdk({ appkey: process.env.REACT_APP_CHAT_APP_KEY }) // our (41832697#1033304) // default (41117440#383391)
EaseApp.thread.setHasThreadEditPanel(true)

export default WebIM;
